module.exports = __webpack_public_path__ + "static/media/preview.4c0662df.webp";